import React, { useRef, useEffect } from 'react';
import "../styles/Navbar.css";

function closeNavbar() {
  const navChecked = document.querySelector('#navChecked') as HTMLInputElement | null;
  if (navChecked) {
    navChecked.checked = false;
  }
}

function useOutsideAlerter(ref: any) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: Event) {
      if (event.target && ref.current && !ref.current.contains(event.target)) {
        const navChecked = document.querySelector('#navChecked');
        if (navChecked && (event.target as HTMLElement).id !== navChecked.id) {
          closeNavbar();
        }
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref]);
}

function Navbar() {

  const wrapperMenu = useRef(null);
  useOutsideAlerter(wrapperMenu);

  const [anchorEl, setAnchorEl] = React.useState<EventTarget | null>(null);
  const handleClick = (event: Event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div className="blocNav">
      <nav className="nav">
        <div className="menuToggle">
          <input type="checkbox" id="navChecked" />
          <span />
          <span />
          <span />
          <ul className="menu" ref={wrapperMenu}>
            <li>
              <a onClick={closeNavbar} href="/">
                <p>Accueil</p>
              </a>
            </li>
            <li style={{display: "flex", flexDirection: "row"}}>
              <a onClick={closeNavbar} href="/domains">
                <p>
                  Compétences
                </p>
              </a>
            </li>
            {/* <li>
              <a onClick={closeNavbar} href="/honorary">
                <p>Honoraires</p>
              </a>
            </li> */}
            {/* <li>
              <a onClick={closeNavbar} href="/mentions">
                <p>Mentions légales</p>
              </a>
            </li> */}
            <li>
              <a onClick={closeNavbar} href="/contact">
                <p>Contact</p>
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
}

export default Navbar;
